import React from 'react'
import AuthCardComponent from '../../components/login-card/auth-card.component'
import BackButton from '../../components/button/back-button'
import { Button, Typography } from 'antd'
import { useNavigate } from 'react-router-dom'

const UndefinedUserPage = () => {
    const navigate = useNavigate();
    return (
        <div className='user-setting-layout' style={{ minHeight: 'calc(100vh - 180px)' }}>
            <div className='d-flex flex-column w-100 h-100'>
                <div className='w-100'>
                    <BackButton path='/auth/login' />
                </div>
                <div className='d-flex align-items-center justify-content-center h-100'>
                    <AuthCardComponent
                        style={{ minHeight: 'auto', height: '300px', width: '620px' }}
                        title="We couldn’t find your account"
                        description={<Typography.Text style={{ fontSize: '16px' }}>
                            It looks like the email you entered isn’t tied to a registered account in our system. <br />
                            <br />
                            Access to this reimbursement portal is available only to participants who enrolled in the Savings Card program. If you believe this is an error or need help confirming your enrollment, please contact our Customer Care team <Button
                                className='p-0'
                                color="default"
                                variant="link"
                                onClick={() => { navigate('/contact-us') }}
                                style={{ color: 'var(--primary-button-color)', fontSize: '16px' }}
                            >
                                here
                            </Button>.
                        </Typography.Text>}
                    />
                </div>
            </div>
        </div>
    )
}

export default UndefinedUserPage